<template>
	<div :class="{'has-error': mensagemErro}">
		<label>
			<span v-if="obrigatorio" class="no-print">*</span> {{ label }}:
		</label>
		<slot />
		<textarea
			class="form-control"
			:value="value"
			@input="$emit('input', $event.target.value)"
			:rows="tamanho"
			:disabled="disabled"
			:maxlength="maxlength"
		></textarea>
		<p class="help-block" v-show="mensagemErro">{{ mensagemErro }}</p>
	</div>
</template>

<script>
export default {
	props: {
		label: {
			type: String,
			required: true
		},

		value: {
			type: String,
			required: false,
			default: ''
		},

		mensagemErro: {
			type: String,
			required: false,
			default: ''
		},

		obrigatorio: {
			type: Boolean,
			required: false,
			default: false
		},

		tamanho: {
			type: Number,
			required: false,
			default: 3
		},

		disabled: {
			type: Boolean,
			required: false,
			default: false
		},

		maxlength: {
			type: String,
			required: false,
			default: ''
		}
	}
}
</script>